import WhatsappGroupsAPI from '../../api/whatsappGroups';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isSyncing: false,
  },
};

const getters = {
  getGroups(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

const actions = {
  get: async ({ commit }) => {
    commit('setUIFlag', { isFetching: true });
    try {
      const response = await WhatsappGroupsAPI.get();
      commit('setGroups', response.data.payload || []);
    } finally {
      commit('setUIFlag', { isFetching: false });
    }
  },
  sync: async ({ commit }) => {
    commit('setUIFlag', { isSyncing: true });
    try {
      await WhatsappGroupsAPI.sync();
    } finally {
      commit('setUIFlag', { isSyncing: false });
    }
  },
};

const mutations = {
  setGroups(_state, data) {
    _state.records = data;
  },
  setUIFlag(_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
